import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import {
  workflowDestinations,
  ZWorkflow,
} from "src/business/workflow/ZWorkflow";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

export const columns: RtColumn<ZWorkflow>[] = [
  columnDisplayId,
  {
    key: "displayName",
    title: "Название рабочего потока",
    render: (row) => getWorkflowDisplayName(row),
    minWidth: 180,
  },
  {
    key: "description",
    title: "Описание",
    render: (row) => row.description,
    minWidth: 220,
  },
  {
    key: "catalog",
    title: "Каталог",
    render: (row) => row.catalog?.label,
    minWidth: 100,
  },
  {
    key: "owner",
    title: "Владелец",
    render: (row) => row.owner?.label,
    minWidth: 100,
  },
  {
    key: "destination",
    title: "Назначение потока",
    render: (row) =>
      row.destination ? workflowDestinations[row.destination] : undefined,
    minWidth: 160,
  },
  ...sysColumnsHistory,
];
